import { TrackedImage } from "../components/ui/TrackedImage";
import logoBlueLong from "../assets/brand/logos/AzulOscuroLargo.png";
import logoBlueMedium from "../assets/brand/logos/AzulOscuroMedio.webp";
import logoBlueShort from "../assets/brand/logos/AzulOscuroCorto.png";
import logoPencaWhite from "../assets/brand/penca/LogoPencaBlanco.webp";
import closingBackground from "../assets/brand/backgrounds/DG2.webp";
import closingBackgroundMobile from "../assets/brand/backgrounds/DG2Mobile.webp";

export function ClosingPage() {
  return (
    <div className="min-h-screen overflow-x-hidden bg-brand-surface text-brand-primary">
      <main className="flex min-h-screen w-full flex-col">
        <section
          className="auth-background flex min-h-screen flex-col"
          style={{
            "--auth-background-image": `url(${closingBackground})`,
            "--auth-background-mobile-image": `url(${closingBackgroundMobile})`,
          }}
        >
          <header className="flex items-start justify-start px-[40px] pt-[40px] sm:justify-between sm:px-[44px] sm:pt-[44px]">
            <TrackedImage
              src={logoBlueLong}
              alt="Penca OSU"
              className="h-[52px] w-auto object-contain sm:hidden"
            />
            <TrackedImage
              src={logoBlueMedium}
              alt="Penca OSU"
              className="hidden h-[52px] w-auto object-contain sm:block sm:h-[72px]"
            />
            <TrackedImage
              src={logoBlueShort}
              alt="Penca OSU"
              className="hidden h-[52px] w-auto object-contain sm:block sm:h-[72px]"
            />
          </header>

          <div className="flex flex-1 items-center justify-center px-4 py-6 sm:px-6 sm:py-10 lg:px-8 lg:py-8">
            <div className="grid w-full max-w-6xl items-stretch overflow-hidden rounded-[2.5rem] bg-brand-surface/95 shadow-[0_28px_90px_rgba(20,50,135,0.16)] backdrop-blur lg:grid-cols-2">
              <div className="relative flex min-h-[340px] h-full flex-col justify-between overflow-hidden bg-brand-primary px-6 py-8 text-white sm:px-8 sm:py-10 lg:px-10 lg:py-12">
                <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(145,190,250,0.22),transparent_44%),radial-gradient(circle_at_bottom_right,rgba(0,0,0,0.12),transparent_30%)]" />

                <div className="relative mx-auto flex w-full flex-1 items-center justify-center px-4">
                  <TrackedImage
                    src={logoPencaWhite}
                    alt="Penca OSU"
                    className="h-auto w-full max-w-[360px] drop-shadow-[0_10px_30px_rgba(0,0,0,0.22)]"
                  />
                </div>

              </div>

              <div className="h-full bg-brand-surface px-5 py-8 sm:px-8 sm:py-10 lg:px-10 lg:py-12">
                <div className="mx-auto flex h-full w-full max-w-lg flex-col justify-center">
                  <div className="text-center">
                    <p className="font-display text-[2rem] font-medium leading-[0.98] text-brand-accent-light sm:text-[2.85rem]">
                      ¡Gracias a todos por participar!
                    </p>
                    <p className="mx-auto mt-5 max-w-md text-base leading-7 text-slate-700 sm:text-lg">
                      Felicitaciones a los ganadores, y gracias por haber sido
                      parte de esta edición de la penca. ¡Nos reencontramos la
                      próxima!
                    </p>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
